import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export const FLEX_RECIPES_WEB_FLAG = 'turnips_ofx_flex_recipes_web'

export const useFlexRecipesWeb = () => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const [decision] = useDecision(FLEX_RECIPES_WEB_FLAG)

  return isAuthenticated && decision.variationKey === 't1'
}
